import styled from 'styled-components';

const Svg = styled.svg`
  width: 100%;
  height: 100%;
  fill: currentColor;
  vertical-align: middle;
`;

export default Svg;
